import { useQuery } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';

const { CONTROLLERS: { SCHEDULE_INCOME: { VERSION, BASE } } } = USER;

export const useGetScheduleIncomeQuery = ({ customerId, year, onSuccess }: { customerId: string, year: number, onSuccess?: (data:any) => void }) => useQuery(
  'ScheduleIncome',
  async () => {
    if (!customerId || !year) {
      return null;
    }
    const { data } = await httpService.get((`${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}?year=${year}`));
    return data;
  },
  {
    enabled: false,
    onSuccess: (data: any) => {
      if (onSuccess) onSuccess(data);
    },
  },
);
